import type { RoutingRule } from "./types";

// Pure projection used by the queue detail page. Rules with a matching
// `targetQueueId` are surfaced enabled-first, then alphabetized by
// description (locale + case-insensitive) so the queue admin sees
// actionable rules at the top.
//
// Lives in its own module so the section component stays composition-
// only and so the sort/filter ordering can be unit-tested without
// dragging React / React Query into the test.
export function filterRulesForQueue(
    rules: readonly RoutingRule[],
    queueId: string,
): RoutingRule[] {
    return rules
        .filter((r) => r.targetQueueId === queueId)
        .sort((a, b) => {
            if (a.isEnabled !== b.isEnabled) return a.isEnabled ? -1 : 1;
            return a.description.localeCompare(b.description, undefined, {
                sensitivity: "base",
            });
        });
}
